import { Card, Typography, Button } from '@insurely/ui';

import { useIntl } from 'react-intl';

import styles from './onboardingCard.module.css';

export interface OnboardingCardProps {
  onClick: () => void;
  imgSrc: string;
}

export const OnboardingCard = ({ onClick, imgSrc }: OnboardingCardProps) => {
  const intl = useIntl();
  return (
    <Card className={styles.mainCard}>
      <img alt="" aria-hidden className={styles.cardImage} src={imgSrc} />
      <Typography component="h1" variant="Headline-5" className={styles.sectionHeadline}>
        {intl.formatMessage({
          id: 'overview.wealth.onboarding-title',
          defaultMessage: 'Simplify your life',
        })}
      </Typography>
      <Typography component="p" variant="ParagraphBodySmall" className={styles.sectionHeadline}>
        {intl.formatMessage({
          id: 'overview.wealth.onboarding-text',
          defaultMessage:
            'View all your pension, investments and saving in one place, no matter the bank.',
        })}
      </Typography>
      <Button variant="primary" fullWidth onClick={onClick}>
        {intl.formatMessage({
          id: 'overview.wealth.onboarding-button-text',
          defaultMessage: 'Add accounts',
        })}
      </Button>
    </Card>
  );
};
